import React from "react";
import ManageGroup from "./manageUserGroup/ManageGroup";
import styles from "./ManageUserLegacy.module.scss";

import CreateAccountUser from "./createUserAccount/CreateAccountUser";
import ManageCabines from "../manageSubscriptions/ManageCabines";
import CabBySubscriptions from "../manageSubscriptions/CabBySubscriptions";
import Axios from "../../_services/caller.service";
// import CreateAccountUser from "./createUserAccount/CreateAccountUser";

const ManageUserLegacy = () => {
  const handleCreateUser = async () => {
    try {
      const response = await Axios.post(`createUserAndSubscription`, {
        login: "jeanrené",
        password: "motdepasse12d3",
        email: "jean.rene@example.com",
        name: "Jean",
        lastName: "Dupont",
        role_id: 2,
        support_level_id: 1,
        subscriptionName: "Abonnement Pro",
        subscriptionVariation: "pro",
        cabname: "Cabine Test",
        cabtype: "Type X",
        machine: "Machine 1",
        features: "Dirac,AvoidAdminCheck",
      });

      console.log("✅ Succès :", response.data);
      alert("Utilisateur et abonnement créés !");
    } catch (error) {
      console.error("❌ Erreur :", error.response?.data || error.message);
      alert("Une erreur est survenue.");
    }
  };

  return (
    <div className={styles.container}>
      <button onClick={handleCreateUser} className={styles.testButton}>
        test envoie d'un formulaire complet pour création d'un utilisateur et
        abonnement et cabines
      </button>
      <CabBySubscriptions />
      <CreateAccountUser />
      <ManageCabines />
      <ManageGroup />
    </div>
  );
};

export default ManageUserLegacy;
